export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/phone-right.a9a02486-c078b3.png";